<template><!-- s::PAGE -->

  <div v-if="loading" class="loading"></div>

  <!-- s::PAGE -->
  <div v-else class="contents">
    <!-- s:: MYPAGE -->
    <div class="mypage">
      <div class="layout">
        <div class="box">
          <div ref="sideRef" class="side-box">
            <div class="snb2">
              <MypageSnb/>
            </div>
          </div>

          <div class="content-panel">
            <div class="my-artartist">
              <div class="my-portfolio">
                <div class="title-wrap">
                  <h2 ref="SeeMoreTopRef" class="section-title">PORTFOLIO</h2>
                </div>
                <div class="button-box portfolio-btn portfolio-header">
                  <button
                      v-for="(btn, index) in filteredButtons"
                      :key="btn.id"
                      :class="{ active: selectedIndex === index }"
                      @click="selectButton(index, btn.handler)"
                  >
                    {{ btn.label }}
                  </button>
                </div>

                <PortfolioArtistProfile v-if="selectedArtist" :artist="selectedArtist" :field-visibility="fieldVisibility" :reload="reload"/>
                <PortfolioArtistArtWork :art-works="selectedArtWorks" :art-works-portfolio-category="PORTFOLIO"/>

                <div class="button-box portfolio-btn portfolio-footer">
                  <button @click="selectSizeModalVisible = true;" type="button">포트폴리오 크기 설정({{ portfolioTemplateName }})</button>
                  <button @click="PdfGeneratePanelVisible = true;" type="button">포트폴리오 파일 생성</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- s:: OUTPUT PORTFOLIO -->

    <PdfGeneratePanel v-if="PdfGeneratePanelVisible"
                      :artist="selectedArtist"
                      :art-works="selectedArtWorks"
                      :pdf-setting-config="pdfSettingConfig"
                      :field-visibility="fieldVisibility"
                      :profile-page-layout-config="profilePageLayoutConfig"
                      :auto-download="pdfAutoDownload"
                      :art-works-portfolio-category="PORTFOLIO"
                      @downloaded="pdfAutoDownload = false"
                      @close="PdfGeneratePanelVisible=false"
    />
    <!-- @update:field-visibility="val => fieldVisibility = {...val}" -->
    <!-- e:: OUTPUT PORTFOLIO -->

    <!-- s::모달창 등록-->
    <PdfSelectSizeModal v-if="selectSizeModalVisible" @close="selectSizeModalVisible=false" @confirm="updatePdfSettings"/>
    <!-- e::모달창 등록-->

  </div>


</template>
<script setup>
import {computed, nextTick, onMounted, ref} from "vue";
import MypageSnb from "@/components/snb/MypageSnb.vue";
import PortfolioArtistProfile from "@/components/portfolio/PortfolioArtistProfile.vue";
import PdfGeneratePanel from "@/components/portfolio/PdfGeneratePanel.vue";
import PdfSelectSizeModal from "@/components/portfolio/PdfSelectSizeModal.vue";
import {apiClient} from "@/services/auth-header";
import PortfolioArtistArtWork from "@/components/portfolio/PortfolioArtistArtWork.vue";
import {useDeviceStore} from "@/store/deviceStore";

const deviceStore = useDeviceStore();
const isMobile = computed(() => deviceStore.isMobile);


const loading = ref(true);

const PORTFOLIO = 'PORTFOLIO';
const portfolioTemplateName = ref('A4/가로');
const selectedIndex = ref(0)

const PdfGeneratePanelVisible = ref(false);
const selectSizeModalVisible = ref(false);

const visibleButtons = ref([
  {
    id: 0,
    label: '새 포트폴리오 만들기',
    handler: () => fetchPortfolio(),
  },
  {
    id: 1,
    label: '최근 포트폴리오 불러오기',
    handler: () => fetchSavedPortfolio(true),
  }
]);

const hasSavedPortfolio = ref(false)
const filteredButtons = computed(() => {
  return hasSavedPortfolio.value
      ? visibleButtons.value
      : visibleButtons.value.filter(btn => btn.id !== 1)
})

const pdfAutoDownload = ref(false);

const selectButton = async (index, handler) => {
  selectedIndex.value = index;
  handler?.(); // 함수 실행
}

const selectedArtist = ref(null);
const selectedArtWorks = ref(null);
const fieldVisibility = ref(null);
const profilePageLayoutConfig = ref(null);
const pdfSettingConfig = ref(null);
const reload = ref(false);

const setPortfolioData = async (data) => {
  if (!data) {
    alert("데이터 로드 실패");
    return;
  }
  selectedArtist.value = {...data.artistProfile};
  selectedArtWorks.value = [...data.artistArtWorks];
  fieldVisibility.value = {...data.profileVisibility};
  profilePageLayoutConfig.value = {...data.profilePageLayoutConfig}
  pdfSettingConfig.value = {...data.pdfSettingConfig}
  reload.value = true;
}


const checkSavedPortfolio = async () => {
  try {
    const response = await apiClient.get('/v1/artists/me/portfolio/saved/exists');
    hasSavedPortfolio.value = response.data; // true 또는 false
    if(hasSavedPortfolio.value) {
      selectedIndex.value = 1;
    }
  } catch (error) {
    console.error('포트폴리오 존재 여부 확인 실패', error)
  }
}


const fetchPortfolio = async () => {
  reload.value = false;
  try {
    const response = await apiClient.get('/v1/artists/me/portfolio');
    await setPortfolioData(response.data);
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    loading.value = false;
  }
};

const fetchSavedPortfolio = async (isTemporary = false) => {
  reload.value = false;
  try {
    const response = await apiClient.get('/v1/artists/me/portfolio/saved', {params: {isTemporary}});
    await setPortfolioData(response.data);
    return true;
  } catch (error) {
    selectedIndex.value = 0;
    await selectButton(selectedIndex.value, visibleButtons.value[selectedIndex.value].handler);
    return false;
  } finally {
    loading.value = false;
  }
};

/* s: pdf size 설정*/
const updatePdfSettings = (newSettings) => {
  const [width, height] = newSettings.size;
  pdfSettingConfig.value.pageWidth = width;
  pdfSettingConfig.value.pageHeight = height;
  pdfSettingConfig.value.orientation = newSettings.orientation;
  portfolioTemplateName.value = newSettings.name;
};
/* e: pdf size 설정 */

const initPortfolioData = async () => {
  //await fetchPortfolio();
  await checkSavedPortfolio();
  await selectButton(selectedIndex.value, visibleButtons.value[selectedIndex.value].handler);
}
onMounted(async () => {
  await initPortfolioData();
  loading.value = false;

  if(isMobile.value) {
    alert("포트폴리오 제작 기능은 PC 화면에 최적화되어 있어요. 모바일 접속 시 미리보기 화면과 실제 PDF 파일에 차이가 발생할 수 있습니다. 데스크톱이나 노트북으로 더 편리하게 이용하세요.");
  }
});


</script>

<style scoped>

.contents {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

</style>